<div class="d-flex justify-content-between rs-list-of-items-in-order__events">
  <div class="rs-list-of-items-in-order__amount">
    <mat-checkbox
      (change)="selectAllItems($event.checked)"
      *ngIf="showCheckboxes"
      [checked]="everyItemInCartIsSelected"
    ></mat-checkbox>

    {{ amount | rsCartItemsAmount | rsEasternArabicNumerals }}
  </div>

  <a (click)="goToOrdering()" [id]="id.Cart.orderMore">
    <div class="rs-list-of-items-in-order__order-more">
      <mat-icon [svgIcon]="addOutlineIcon"></mat-icon>
      {{ 'PAY_NOW.ORDER_MORE' | translate | uppercase }}
    </div>
  </a>
</div>
<div>
  <ng-template [ngForOf]="items" let-item ngFor>
    <div class="w-100 rs-list-of-items-in-order__item">
      <ng-container
        *ngFor="
          let isThereAnyAvailableOrderMethods of [
            isThereAnyAvailableOrderMethods$ | async
          ]
        "
      >
        <ng-template [ngIf]="!isThereAnyAvailableOrderMethods">
          <rs-banner-alert
            class="d-block w-fit-content mt-3 mb-2"
            rs-rounded="true"
            rs-status="error"
          >
            {{ 'MENUS.unavailable_all_order_types' | translate }}
          </rs-banner-alert>
        </ng-template>

        <ng-container *ngFor="let orderType of [orderType$ | async]">
          <ng-container
            *ngFor="
              let isItemUnavailable of [
                !isThereAnyAvailableOrderMethods ||
                  (showCheckboxes &&
                    (!item.menuAvailabilityForSelectedDeliveryType ||
                      !item.menuAvailabilityAtSelectedTime) &&
                    orderType)
              ]
            "
          >
            <rs-cart-order-item
              [item]="item"
              [showCheckboxes]="showCheckboxes"
              [availableToChange]="itemCanBeChanged"
              [availableToOrder]="
                !isItemUnavailable && !!isThereAnyAvailableOrderMethods
              "
              [bundleItemsNames]="bundleItemsNames$ | async"
              [unavailableMessage]="
                !item.menuAvailabilityForSelectedDeliveryType
                  ? ('MENUS.unavailable_for_orderType'
                    | translate: { orderType: orderType | titlecase })
                  : !item.menuAvailabilityAtSelectedTime
                  ? ('This item is unavailable at the chosen time.' | translate)
                  : ''
              "
              (amountChanged)="
                $event > 0
                  ? increaseItemQuantity.emit(item)
                  : decreaseItemQuantity.emit(item)
              "
              (clickedOnItem)="handleClickByItem(item)"
              (selected)="selectItem(item.cartItemId || '', $event)"
            ></rs-cart-order-item>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>
</div>
